import React from 'react';
import Hero from './components/Hero';
import QuickValue from './components/QuickValue';
import Intro from './components/Intro';
import EditorialQuote from './components/EditorialQuote';
import CinematicGallery from './components/CinematicGallery';
import Expectations from './components/Expectations';
import Incentives from './components/Incentives';
import SocialProof from './components/SocialProof';
import Rsvp from './components/Rsvp';
import Footer from './components/Footer';
import StickyCta from './components/StickyCta';

function App() {
  return (
    <div className="font-sans min-h-screen selection:bg-burgundy selection:text-ivory bg-parchment-pattern overflow-x-hidden">
      <Hero />
      <QuickValue />
      <Intro />
      <EditorialQuote />
      <CinematicGallery />
      <Expectations />
      <Incentives />
      <SocialProof />
      <Rsvp />
      <Footer />
      <StickyCta />
    </div>
  );
}

export default App;